import { useEffect, useState } from "react";
import { LayoutPropsType } from "../../../types/app.type";
import { MainArea } from "../../mainarea";
import { SideNavigation } from "../../navigation/sidenavigation";
import { TopNavigation } from "../../navigation/topnavigation";
import { LayoutWrapper } from "./styled";
import { Avatar } from "@mui/material";
import uploadImageIcon from "../../../assets/profileicon.svg";
import { retrieveUserProfileService } from "../../../utils/apis/usermanagement/user/retrieveUser";
import Cookies from "universal-cookie";

export const Layout: React.FC<LayoutPropsType> = ({ id, children }) => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const [loggedInUser, setLoggedInUser] = useState<Record<string, any>>({});

    useEffect(() => {
        retrieveUserProfileService(TOKEN)
            .then((data) => setLoggedInUser(data))
            .catch((err) => {
                console.error("Failed to fetch logged in user:", err);
            });
    }, [TOKEN]);

    return (
        <LayoutWrapper
            id={id}
            maxWidth={false}
        >
            <TopNavigation
                headshot={
                    <Avatar
                        variant="rounded"
                        src={loggedInUser?.avatar || uploadImageIcon}
                        alt={`${loggedInUser?.firstName} avatar`}
                        className="navigation-avatar"
                    />
                }
            />
            <SideNavigation />
            <MainArea>
                {children}
            </MainArea>
        </LayoutWrapper>
    )
}